import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./Components/Dashboard/Dashboard";
import Home from "./Components/Home/Home";
import Login from "./Components/login/Login";
import Protected from "./Components/protected/Protected";
import Labour from "./Pages/labour/Labour";
import Material from "./Pages/Material/Material";
import AddMaterial from "./Pages/Material/AddMaterial";
import Venders from "./Pages/Material/Venders";
import ViewMachine from "./Pages/Machine/ViewMachine";

import Machine from "./Pages/Machine/Machine";
// import Project from "./Pages/Project/Project";
import EmpList from "./Pages/Attendance/EmpList";
import Attendence from "./Pages/Attendance/Attendence";
import MonthlyReport from "./Pages/Attendance/MonthlyReport";
import MaterialVendor from "./Pages/Material/MaterialVendor";
import WorkerAttendance from "./Pages/Material/WorkerAttendance";
import WorkerManagement from "./Pages/Material/WorkerManagement";
import WorkerAdd from "./Pages/Material/WorkerAdd";
import MaterialVendorDetails from "./Pages/Material/MaterialVendorDetails";
import MaterialLogDetails from "./Pages/Material/MaterialLogDetails";
import MaterialPurches from "./Pages/Material/MaterialPurches";
import MaterialAllDetails from "./Pages/Material/MaterialAllDetails";
import VehicleMaterial from "./Pages/Material/VehicleMaterial";
import MaterialStock from "./Pages/Material/MaterialStock";
import StockSummary from "./Pages/Material/StockSummary";
import Registration from "./Pages/Registration/Registration";
import MaterilOrderSummery from "./Pages/Material/MaterilOrderSummery";
import {
  registerServiceWorker,
  requestNotificationPermission,
  getFcmToken,
  setupForegroundMessaging,
} from "./firebase/firebase-messaging";

import Engineer from "./Pages/Registration/Engineer";
import Vendor from "./Pages/Registration/Vendor";
import Accountant from "./Pages/Registration/Accountant";
import MaterialRegistration from "./Pages/Registration/MaterialRegistration";
import Maintainance from "./Pages/Machine/Maintainance";
import DriverRegistration from "./Pages/Registration/DriverRegistration";
import Tripschedule from "./Pages/Machine/Tripschedule";
import Fuel from "./Pages/Machine/Fuel";
import AOS from "aos";
import "aos/dist/aos.css";
import EditMaterial from "./Pages/Material/EditMaterial";
import CreateVendor from "./Pages/Material/addVendor";
import EngineerPayment from "./Pages/Engineer/EngineerPayment";
import EngineerAttendance from "./Pages/Engineer/EngineerAttendence/EngineerAttendance";
import MarkAttendance from "./Pages/Engineer/EngineerAttendence/MarkAttendance";
import EngineerLeave from "./Pages/Engineer/Engineerleave/Engineerleave";
import Payments from "./Pages/Engineer/EngineersPayment/payment";

function App() {
  useEffect(() => {
    const initFCM = async () => {
      try {
        console.log("Initializing FCM...");
        await registerServiceWorker();
        const permission = await requestNotificationPermission();
        if (permission === "granted") {
          const token = await getFcmToken();
          if (token) {
            console.log(
              "FCM setup complete, setting up foreground messaging..."
            );
            setupForegroundMessaging();
          } else {
            console.warn("Failed to retrieve FCM token");
          }
        } else {
          console.warn("Notification permission denied");
        }
      } catch (error) {
        console.error("FCM initialization failed:", error);
      }
    };

    initFCM();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration (ms)
      easing: "ease-in-out", // animation easing
      once: true, // whether animation should happen only once
      mirror: false, // whether elements should animate out while scrolling past
    });
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<Protected />}>
          <Route path="/" element={<Dashboard />}>
            <Route index element={<Home />} />
            <Route path="labour" element={<Labour />} />
            <Route path="worker-attendance" element={<WorkerAttendance />} />
            <Route path="worker" element={<WorkerManagement />} />
            <Route path="add-worker" element={<WorkerAdd />} />
            <Route path="/add-worker/:id" element={<WorkerAdd />} />
            <Route path="material/:vendorId" element={<Material />} />
            <Route path="venders" element={<Venders />} />
            <Route path="/add-venders" element={<CreateVendor />} />
            <Route path="/add-venders/:id" element={<CreateVendor />} />
            <Route
              path="/materialVendor/:ProjectId/:ProjectName"
              element={<MaterialVendor />}
            />
            <Route path="/add-material/:vendorId" element={<AddMaterial />} />
            <Route path="/edit-material/:id" element={<EditMaterial />} />

            <Route
              path="/MaterialVendorDetails/:VendorId/:ProjectName/:ProjectId"
              element={<MaterialVendorDetails />}
            />
            <Route
              path="/MaterialLogDetails/:id/:name"
              element={<MaterialLogDetails />}
            />

            <Route element={<MaterialPurches />} path="/purchesOrder" />
            <Route
              path="/MaterialAllDetails/:ProjectId/:ProjectName"
              element={<MaterialAllDetails />}
            />
            <Route path="/vehicleMaterial" element={<VehicleMaterial />} />
            <Route path="/MaterialStock" element={<MaterialStock />} />
            <Route
              path="/MaterilOrderSummery/:id/:name"
              element={<MaterilOrderSummery />}
            />
            <Route element={<StockSummary />} path="/StockSummary" />
            <Route path="machine" element={<Machine />} />
            <Route path="view-machine/:id" element={<ViewMachine />} />
            {/* <Route path="project" element={<Project />} /> */}
            <Route path="/empList" element={<EmpList />} />
            <Route path="/attentance" element={<Attendence />} />
            <Route path="/monthlyReport" element={<MonthlyReport />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/engineer" element={<Engineer />} />
            <Route path="/engineer-payment" element={<EngineerPayment />} />
            <Route
              path="/engineer-attendance"
              element={<EngineerAttendance />}
            />
            <Route
              path="/engineer-monthly-report"
              element={<MonthlyReport />}
            />
            <Route path="/engineerLeave" element={<EngineerLeave />} />
            <Route path="/engineerPayment" element={<Payments />} />

            <Route
              path="/engineer-mark-attendance"
              element={<MarkAttendance />}
            />
            <Route path="/Vendor" element={<Vendor />} />
            <Route element={<Accountant />} path="/Accountant" />
            <Route
              element={<MaterialRegistration />}
              path="/materialRegistration"
            />
            <Route element={<Maintainance />} path="/maintainance" />
            <Route
              element={<DriverRegistration />}
              path="/DriverRegistration"
            />
            <Route element={<Tripschedule />} path="/tripschedule" />
            <Route element={<Fuel />} path="/fuel" />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;